import React, { useState } from 'react';
import { Box, Button, Stack, TextField, Typography, alpha } from '@mui/material';
import axiosPublic from '../../../../api/axiosPublic';
import { getRootSubdomain } from '../../../utils/subdomain';
import { getAccentColor } from './shared';

const SubscribeSection = ({ section, sectionIndex, subscribePlaceholder, subscribeButtonLabel, subscribeSuccessMessage, showSnackbar, renderHtmlTextBlock, renderPositionableElement }) => {
  const accent = getAccentColor(section) || '#4F46E5';
  const tenantKey = getRootSubdomain();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const email = String(new FormData(event.currentTarget).get('subscribeEmail') || '').trim();
    if (!email) {
      showSnackbar('Enter email before subscribing.', 'warning');
      return;
    }
    if (!tenantKey) {
      showSnackbar('Website context is missing.', 'error');
      return;
    }
    setSubmitting(true);
    try {
      await axiosPublic.post(`/api/${tenantKey}/website-requests`, {
        requestType: 'NEWSLETTER',
        email,
        sourcePage: typeof window !== 'undefined' ? window.location.pathname : '',
      }, { skipGlobalLoader: true });
      showSnackbar(subscribeSuccessMessage, 'success');
      event.currentTarget.reset();
    } catch (error) {
      showSnackbar(error?.response?.data?.message || 'Failed to subscribe.', 'error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box component="section" sx={{ py: { xs: 0.8, md: 1.2 }, px: 0 }}>
      <Box sx={{ width: '100%', borderRadius: '32px', overflow: 'hidden', position: 'relative', backgroundColor: '#0F172A', color: '#FFFFFF', p: { xs: 4, md: 6 }, textAlign: 'center', boxShadow: `0 24px 48px ${alpha('#0F172A', 0.15)}` }}>
        {/* Abstract Glow */}
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '80%', height: '80%', background: `radial-gradient(circle, ${alpha(accent, 0.4)} 0%, transparent 60%)`, filter: 'blur(60px)', zIndex: 0, pointerEvents: 'none' }} />
        
        <Stack spacing={3} sx={{ position: 'relative', zIndex: 1, alignItems: 'center' }}>
          {section.title && <Typography sx={{ fontWeight: 800, fontSize: { xs: '1.8rem', md: '2.5rem' }, letterSpacing: '-0.02em', lineHeight: 1.1 }}>{section.title}</Typography>}
          {section.body && renderPositionableElement({
            section, index: sectionIndex, elementKey: 'subscribe-intro',
            children: renderHtmlTextBlock(section.body, { color: 'rgba(255,255,255,0.85)', lineHeight: 1.7, fontSize: '1.1rem', textAlign: 'center' }),
          })}
          <Box component="form" sx={{ width: '100%', maxWidth: 500, mt: 2 }} onSubmit={handleSubmit}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
              <TextField fullWidth name="subscribeEmail" type="email" required placeholder={subscribePlaceholder} variant="outlined" InputProps={{ sx: { borderRadius: '100px', backgroundColor: '#FFFFFF', '& fieldset': { border: 'none' } } }} />
              <Button type="submit" disabled={submitting} variant="contained" sx={{ borderRadius: '100px', px: 4, py: 1.8, whiteSpace: 'nowrap', textTransform: 'none', fontWeight: 800, fontSize: '1rem', backgroundColor: accent, color: '#FFFFFF', boxShadow: `0 8px 20px ${alpha(accent, 0.4)}`, '&:hover': { backgroundColor: '#FFFFFF', color: '#0F172A' }, transition: 'all 0.3s' }}>
                {submitting ? 'Submitting...' : subscribeButtonLabel}
              </Button>
            </Stack>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};
export default SubscribeSection;
